<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="orderNum">
        <el-input v-model="queryParams.orderNum" clearable placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item  prop="outNum" >
        <el-input v-model="queryParams.outNum" clearable placeholder="物流单号"></el-input>
      </el-form-item>
      <el-form-item  prop="phone" >
        <el-input v-model="queryParams.phone" clearable placeholder="收货人手机号"></el-input>
      </el-form-item>
      <el-form-item  prop="outStatus" >
        <el-select v-model="queryParams.outStatus" filterable clearable placeholder="发货状态" @change="search">
          <el-option v-for="item in optShipmentStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="orderStatus" v-show="adminShow" >
        <el-select v-model="queryParams.orderStatus" filterable clearable placeholder="订单状态" @change="search">
          <el-option v-for="item in optOrderStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" filterable clearable placeholder="申请状态" @change="search">
          <el-option v-for="item in optStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="申请开始日期"
          end-placeholder="申请结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    
    <div class="table">
      <el-table :data="tableData" border>
        <el-table-column prop="wxMpUserId" label="小程序用户Id" align="center" min-width="180px" :show-overflow-tooltip="true" fixed></el-table-column>
        <el-table-column prop="orderNum" label="卡申请单号" align="center" min-width="260px" fixed></el-table-column>
        <el-table-column prop="orderMoney" label="金额（元）" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="totalNum" label="申请卡总数量" align="center" min-width="180px" ></el-table-column>
        <el-table-column prop="company" label="公司名称" align="center" min-width="180px" ></el-table-column>
        <el-table-column prop="app" label="应用场景" align="center" min-width="180px" ></el-table-column>
        <el-table-column prop="orderStatus" label="支付状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.orderStatus == '1'" type="danger">未支付</el-tag>
            <el-tag v-else-if="row.orderStatus == '2'" type="success">已支付</el-tag>
            <el-tag v-else-if="row.orderStatus == '3'" type="primary">已到账</el-tag>
            <el-tag v-else-if="row.orderStatus == '4'" type="primary">已退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="申请状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.status == '0'" type="danger">拒绝</el-tag>
            <el-tag v-else-if="row.status == '1'" type="warning">审核中</el-tag>
            <el-tag v-else-if="row.status == '2'" type="primary">已通过</el-tag>
            <el-tag v-else-if="row.status == '3'" type="primary">已寄出</el-tag>
            <el-tag v-else type="success">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请时间" align="center" min-width="185px"></el-table-column>

        <el-table-column prop="phone" label="收货手机号" align="center" min-width="120px"></el-table-column>
        <el-table-column prop="outStatus" label="发货状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.outStatus == '1'" type="warning">未发货</el-tag>
            <el-tag v-else type="success">已发货</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="outNum" label="物流单号" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="outCompany" label="物流公司" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="outId" label="发货人" align="center" min-width="200px"></el-table-column>
        <el-table-column prop="outTime" label="发货时间" align="center" min-width="185px"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="185px"></el-table-column>
        <el-table-column label="操作" align="center" width="260" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain icon="el-icon-view" v-hasPermi="['cardTrial:view']" @click="infoRow(scope.row)" >详情</el-button>
              <el-button size="mini" type="primary" plain icon="el-icon-edit" v-hasPermi="['cardTrial:remark']" @click="remarkRow(scope.row)">备注</el-button>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 备注的弹窗 -->
    <div>
      <el-dialog title="备注" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
        <el-form :model="beizhu" ref="beizhu">
          <el-form-item label="备注内容:" prop="remark" label-width="100px">
            <el-input v-model="beizhu.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注内容"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button type="primary" @click="cancelDialog">取消</el-button>
          <el-button type="success" @click="saveDialog">确认</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>
<script>

import { listPageCardTrial } from "@/api/api.js"; //卡试用申请列表
import { cardTrialSaveRemark } from "@/api/api.js"; //卡试用申请备注
export default {
  name:"cardTrial",
  data() {
    return{
      queryParams:{
        orderNum:undefined,
        outNum:undefined,
        phone:undefined,
        orderStatus:undefined,
        outStatus:undefined,
      },
      tableData:[],
      dateRange: [],
      page: 1,
      pageSize: 20,
      total:0,
      agentList: [],
      optOrderStatus: [
        { value: 1, label: "未支付" },
        { value: 2, label: "已支付" },
        { value: 3, label: "已到账" },
        // { value: 4, label: "已退款" }
      ],
      optShipmentStatus:[
         { value: 2, label: "已发货" },
         { value: 1, label: "未发货" },
      ],
      optStatus:[
        { value: 0, label: "拒绝" },
        { value: 1, label: "审核中" },
        { value: 2, label: "已通过" },
        { value: 3, label: "已寄出" },
      ],
      dialog:false,
      beizhu:{}
    }
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize
      }
      listPageCardTrial(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    // 详情
    infoRow(row){
      this.$router.push(`/device/cardTrialDetail/`+row.orderNum);
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 备注
    remarkRow(row){
      this.beizhu = {};
      this.dialog = true;
      this.beizhu = Object.assign({}, row);
    },
    // 关闭弹窗
    dialogClose(){
      this.$refs.beizhu.clearValidate();
      this.dialog = false;
    },
    // 弹窗的取消按钮
    cancelDialog(){
      this.dialog = false;
    },
    // 弹窗的确认按钮
    saveDialog(){
      // this.dialog = false;
      let params = {
        remark:this.beizhu.remark,
        id:this.beizhu.id,
      };
      cardTrialSaveRemark(params).then(res =>{
        if(res.data.code == 200){
          this.$message.success("备注成功");
          this.dialog = false;
          this.beizhu = {};
          this.initData()
        }
      })
    },
  },
  mounted() {
    this.initData()
  },
  created() {

  }
};
</script>
<style scoped lang="less">

</style>


